import { render, staticRenderFns } from "./VehicleObject.vue?vue&type=template&id=81c9961e&lang=pug&"
import script from "./VehicleObject.vue?vue&type=script&lang=ts&"
export * from "./VehicleObject.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleObject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports